<div class="pipe_code">
    <div class="row">
        <div class="col-md-4">
            <div class="card-custom code_box">
                <div class="code-box_title">
                    <div class="title">
                        <h4>{{ 'SETTING_PAGE.IDMS_SETTINGS.PIPE_SPECIFICATION' | transloco }}</h4>
                        <!-- <button class="btn btn-primary" (click)="consoleForm()">Form</button> -->
                    </div>
                    <div class="icon-wrapper">
                        <button
                            *ngIf="createPipeCodes || EditPipeCodes"
                            class="mat-tooltip-trigger btn primary-ebtn"
                            matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.RECALCULATE' | transloco }}"
                            [matTooltipPosition]="'above'"
                            [disabled]="disableRecalculate()"
                            (click)="recalculateCodes('pipecodes')"
                        >
                            <!-- <i class="fa-solid fa-rotate-right"></i> -->
                            <mat-icon>refresh</mat-icon>
                        </button>

                        <button class="mat-tooltip-trigger btn primary-ebtn" *ngIf="createPipeCodes" [disabled]="disableSpec()" (click)="addpipeCodes()">
                            <!-- <i class="fa fa-plus"></i> -->
                            <mat-icon class="" matTooltip="Add">add</mat-icon>
                        </button>
                    </div>
                </div>
                <div class="code_metrial">
                    <div *ngFor="let pipe of pipeCodes; let i = index">
                        <div
                            class="material_box"
                            (click)="clickActive(pipe)"
                            [formGroup]="idmsFormGroup.get('pipeCodes').controls[i]"
                            [ngClass]="
                                selectedPipeCode !== null &&
                                (selectedPipeCode?.pipeCodeId ? selectedPipeCode?.pipeCodeId == pipe?.pipeCodeId : selectedPipeCode?.name == pipe?.name)
                                    ? 'active'
                                    : ''
                            "
                        >
                            <div class="row align-items-center" (click)="clickActive(pipe)">
                                <div class="col-4">
                                    <div class="d-flex align-items-center">
                                        <div class="check-box">
                                            <mat-checkbox class="example-margin checkbox-wrap" formControlName="isCheck"></mat-checkbox>
                                        </div>
                                        <mat-form-field class="custom-text-field">
                                            <input
                                                matInput
                                                type="text"
                                                formControlName="name"
                                                (click)="clickActive(pipe)"
                                                placeholder="Name"
                                                name="title"
                                                readonly
                                            />
                                            <span class="text-danger" *ngIf="idmsFormGroup?.get(['pipeCodes', i, 'name'])?.hasError('duplicateName')"
                                                >Pipe Code Name is already exist!</span
                                            >
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <mat-form-field class="custom-text-field">
                                        <input
                                            matInput
                                            type="text"
                                            formControlName="description"
                                            placeholder="Description"
                                            (click)="clickActive(pipe)"
                                            name="Description"
                                            readonly
                                        />
                                    </mat-form-field>
                                </div>
                                <div class="col-2">
                                    <div class="d-flex justify-content-center">
                                        <div class="btn-group custom-toggle-wrap" role="group">
                                            <label
                                                *ngFor="let opt of getFilteredStateOptions(pipe)"
                                                class="btn custom-toggle"
                                                [class.active]="opt.value === idmsFormGroup.get('pipeCodes').controls[i].get('pipeSizeType')?.value"
                                            >
                                                <input
                                                    type="radio"
                                                    class="btn-check"
                                                    [value]="opt.value"
                                                    [formControl]="idmsFormGroup.get('pipeCodes').controls[i].get('pipeSizeType')"
                                                    autocomplete="off"
                                                />
                                                {{ opt.label }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="social_icon text-center">
                                        <!-- <i class="flaticon2-pen"></i> -->
                                        <mat-icon *ngIf="EditPipeCodes">
                                            <a
                                                href="javascript:void(0)"
                                                href="javascript:void(0)"
                                                #tooltip="matTooltip"
                                                matTooltip="Edit"
                                                [matTooltipPosition]="tooltip_position"
                                                (click)="editPipeSpec(pipe)"
                                                >edit</a
                                            >
                                        </mat-icon>

                                        <a
                                            href="javascript:void(0)"
                                            #tooltip="matTooltip"
                                            matTooltip="Delete"
                                            [matTooltipPosition]="tooltip_position"
                                            *ngIf="deletePipeCodes"
                                        >
                                            <i class="flaticon2-cross" (click)="deletePipeCode(pipe, 1, i)"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-8">
            <div class="card-custom code_box code_details_box mb-10">
                <div class="code_details_title" *ngIf="selectedPipeCode">
                    <div class="row">
                        <div class="col-lg-8 col-xxl-9">
                            <div class="title-wrap">
                                <h4>
                                    {{ 'SETTING_PAGE.IDMS_SETTINGS.CONFIGURE_PIPE_SPECIFICATION_CODE' | transloco }}
                                    <span>{{ selectedPipeCode?.name }}</span> {{ 'SETTING_PAGE.IDMS_SETTINGS.PIPESIZE_UNIT' | transloco }}
                                    <span>{{ selectedPipeCode?.pipeSizeType == 0 ? 'mm' : 'In' }}</span>
                                </h4>
                            </div>
                        </div>
                        <div class="col-lg-4 col-xxl-3">
                            <div class="btn-wrap">
                                <div
                                    matTooltip="{{ 'SETTING_PAGE.IDMS_SETTINGS.RECALCULATE' | transloco }}"
                                    *ngIf="EditPipeCodes && !disableRecalculate()"
                                    [matTooltipPosition]="'above'"
                                >
                                    <svg
                                        (click)="recalculateCodes('pipespecs')"
                                        clas="svg-img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        width="25px"
                                        height="25px"
                                        viewBox="0 0 100 100"
                                        preserveAspectRatio="xMidYMid"
                                        style="margin-right: 3px; display: block; animation-play-state: paused"
                                    >
                                        <g transform="matrix(1,0,0,1,0,0)" style="transform: matrix(1, 0, 0, 1, 0, 0); animation-play-state: paused">
                                            <path
                                                d="M50 15A35 35 0 1 0 74.74873734152916 25.251262658470843"
                                                fill="none"
                                                stroke="#757575"
                                                stroke-width="12"
                                                style="animation-play-state: paused"
                                            ></path>

                                            <path d="M49 3L49 27L61 15L49 3" fill="#757575" style="animation-play-state: paused"></path>
                                        </g>
                                    </svg>
                                </div>

                                <button class="btn btn-sm primary-ebtn" *ngIf="EditPipeCodes" [disabled]="disableCombination()" (click)="addCombination()">
                                    {{ 'SETTING_PAGE.IDMS_SETTINGS.ADD_NEW_COMBINATION' | transloco }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="">
                    <div class="code_details_inside card_text_center" *ngIf="configure">
                        <div class="tab-main-header-wrap">
                            <div class="add-new-btn">
                                <button
                                    class="btn secondary-ebtn"
                                    *ngIf="EditPipeCodes && pipeSpecs?.pipeSpecs?.length"
                                    [disabled]="disableVersrion()"
                                    (click)="addNewVersions()"
                                >
                                    {{ 'SETTING_PAGE.IDMS_SETTINGS.ADD_NEW_VERSION' | transloco }}
                                </button>
                            </div>
                            <div class="example-tab-wrapper">
                                <mat-tab-group
                                    #tabGroup
                                    class="example-tab pipespec-tab"
                                    [(selectedIndex)]="selectedTabIndex"
                                    (selectedTabChange)="handleTabChangeEvent($event)"
                                >
                                    <!-- <pre>{{ pipeSpec | json }}</pre> -->
                                    <mat-tab *ngFor="let pipeSpec of pipeSpecs?.pipeSpecs; let j = index">
                                        <ng-template mat-tab-label class="close-icon">
                                            {{ pipeSpec.name }}
                                            <a
                                                href="javascript:void(0)"
                                                class="edit_icon fo"
                                                #tooltip="matTooltip"
                                                matTooltip="Edit"
                                                [matTooltipPosition]="tooltip_position"
                                                (click)="editpipeSpecCombination(pipeSpec, j)"
                                                *ngIf="EditPipeCodes"
                                            >
                                                <i class="flaticon2-pen"></i>
                                            </a>

                                            <a
                                                class="close-icon"
                                                (click)="deletePipeCode(pipeSpec, 2, j)"
                                                ngbAutofocus
                                                matTooltip="Delete"
                                                [matTooltipPosition]="tooltip_position"
                                            >
                                                <i *ngIf="deletePipeCodes" class="flaticon2-cross"></i>
                                            </a>
                                        </ng-template>

                                        <app-pipe-specification-code
                                            *ngIf="selectedPipeSpec == pipeSpec"
                                            [pipeSpec]="selectedPipeSpec"
                                            [calculationType]="pipeSpec?.versions[0]?.calculationType"
                                            (CopyClick)="copyClick($event)"
                                            (deleteClick)="deleteClick($event)"
                                        ></app-pipe-specification-code>
                                    </mat-tab>
                                </mat-tab-group>
                            </div>
                        </div>
                    </div>

                    <div class="code_details_inside card_text_center" *ngIf="!configure">
                        <div class="configure-wrap">
                            <h3>{{ 'SETTING_PAGE.IDMS_SETTINGS.SELECT_YOUR_CODE_TO_CONFIGURE' | transloco }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
